import { Injectable } from '@angular/core';
import { config } from '@tag/graphql';
import type { GraphQLParams, Timesheet } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';

export interface Response {
  timesheets: { items: Timesheet[]; totalCount: number };
}

@Injectable({
  providedIn: 'root',
})
export class TimesheetsGQL extends Query<Response, GraphQLParams<'timesheet'>> {
  document = gql(config.timesheet.query);
}
